import React from 'react';
import { Outlet } from 'react-router-dom';
import { Header } from './Header';
import { Footer } from './Footer';
import { StickyQuoteButton } from '../common/StickyQuoteButton';
import { WhatsAppButton } from '../common/WhatsAppButton';
import { Toaster } from '../ui/sonner';

export const Layout = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
      <StickyQuoteButton />
      <WhatsAppButton />
      <Toaster position="top-right" />
    </div>
  );
};

export default Layout;
